import React from 'react';
import { Link } from '@mui/material';

/**
 * Matches "Lat 23.578651428223, Lon 58.416988372803" or "Lat: 23.57, Lon: 58.41" etc.
 * and renders that part as a Google Maps link.
 */
const LAT_LON_REGEX = /Lat\s*:?\s*([\d.+-]+)\s*,\s*Lon\s*:?\s*([\d.+-]+)/i;

export function descriptionWithMapLink(description: string | null | undefined): React.ReactNode {
  const text = description?.trim() || '';
  if (!text) return null;

  const match = text.match(LAT_LON_REGEX);
  if (!match) {
    return text;
  }

  const lat = match[1];
  const lon = match[2];
  const url = `https://www.google.com/maps?q=${lat},${lon}`;
  const before = text.substring(0, match.index!);
  const after = text.substring(match.index! + match[0].length);

  return (
    <>
      {before}
      <Link
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: 'primary.main', fontWeight: 600, whiteSpace: 'nowrap' }}
      >
        View on Google Maps
      </Link>
      {after}
    </>
  );
}

export default descriptionWithMapLink;
